// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"8b5d8084","748":"af7cb397","757":"9369d1f0"}[chunkId] + ".chunk.css";
};